import React from 'react';
import styles from './WhyEpen.module.scss';
import Reveal from 'react-awesome-reveal';
import { flipFromLeft } from '../Animation/Animation';
import { Typography } from '../Typography';

const WhyEpen = () => {
  const pillars = [
    {
      icon: (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.09436 10.2288C5.03221 9.82823 4.99996 9.41786 4.99996 9C4.99996 4.58172 8.60525 1 13.0526 1C17.4999 1 21.1052 4.58172 21.1052 9C21.1052 9.99807 20.9213 10.9535 20.5852 11.8345C20.5154 12.0175 20.4804 12.109 20.4646 12.1804C20.4489 12.2512 20.4428 12.301 20.4411 12.3735C20.4394 12.4466 20.4493 12.5272 20.4692 12.6883L20.8717 15.9585C20.9153 16.3125 20.9371 16.4895 20.8782 16.6182C20.8266 16.731 20.735 16.8205 20.6211 16.8695C20.4911 16.9254 20.3146 16.8995 19.9617 16.8478L16.7765 16.3809C16.6101 16.3565 16.527 16.3443 16.4512 16.3448C16.3763 16.3452 16.3245 16.3507 16.2511 16.3661C16.177 16.3817 16.0823 16.4172 15.893 16.4881C15.0097 16.819 14.0524 17 13.0526 17C12.6344 17 12.2237 16.9683 11.8227 16.9073M6.63158 21C9.59648 21 12 18.5376 12 15.5C12 12.4624 9.59648 10 6.63158 10C3.66668 10 1.26316 12.4624 1.26316 15.5C1.26316 16.1106 1.36028 16.6979 1.53955 17.2467C1.61533 17.4787 1.65322 17.5947 1.66566 17.6739C1.67864 17.7567 1.68091 17.8031 1.67608 17.8867C1.67145 17.9668 1.65141 18.0573 1.61134 18.2383L1 21L3.9948 20.591C4.15827 20.5687 4.24 20.5575 4.31137 20.558C4.38652 20.5585 4.42641 20.5626 4.50011 20.5773C4.5701 20.5912 4.67416 20.6279 4.88227 20.7014C5.43059 20.8949 6.01911 21 6.63158 21Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Performance-Driven',
      description: 'Engineering excellence with a strong focus on performance and scalability',
    },
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Production-Ready',
      description: 'Deep domain knowledge in video processing and software architecture',
    },
    {
      icon: (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V15.2C1 16.8802 1 17.7202 1.32698 18.362C1.6146 18.9265 2.07354 19.3854 2.63803 19.673C3.27976 20 4.11984 20 5.8 20H14.2C15.8802 20 16.7202 20 17.362 19.673C17.9265 19.3854 18.3854 18.9265 18.673 18.362C19 17.7202 19 16.8802 19 15.2V12M10 7H14V11M13.5 2.5V1M17.4393 3.56066L18.5 2.5M18.5103 7.5H20.0103M1 12.3471C1.65194 12.4478 2.31987 12.5 3 12.5C7.38636 12.5 11.2653 10.3276 13.6197 7"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Deep Technical Focus',
      description: 'Reliable, maintainable solutions designed for long-term use',
    },
    {
      icon: (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.60802 12C7.60802 12 8.92052 13.5 11.108 13.5C13.2955 13.5 14.608 12 14.608 12M13.858 7H13.868M8.35802 7H8.36802M11.108 18C15.8024 18 19.608 14.1944 19.608 9.5C19.608 4.80558 15.8024 1 11.108 1C6.4136 1 2.60802 4.80558 2.60802 9.5C2.60802 10.45 2.76387 11.3636 3.05139 12.2166C3.15959 12.5376 3.21369 12.6981 3.22345 12.8214C3.23309 12.9432 3.2258 13.0286 3.19568 13.1469C3.16517 13.2668 3.09782 13.3915 2.96312 13.6408L1.32746 16.6684C1.09415 17.1002 0.977493 17.3161 1.0036 17.4828C1.02634 17.6279 1.11177 17.7557 1.2372 17.8322C1.3812 17.9201 1.62532 17.8948 2.11356 17.8444L7.23459 17.315C7.38967 17.299 7.46721 17.291 7.53788 17.2937C7.6074 17.2963 7.65647 17.3029 7.72426 17.3185C7.79318 17.3344 7.87984 17.3678 8.05318 17.4345C9.00123 17.7998 10.0312 18 11.108 18ZM14.358 7C14.358 7.27614 14.1342 7.5 13.858 7.5C13.5819 7.5 13.358 7.27614 13.358 7C13.358 6.72386 13.5819 6.5 13.858 6.5C14.1342 6.5 14.358 6.72386 14.358 7ZM8.85802 7C8.85802 7.27614 8.63417 7.5 8.35802 7.5C8.08188 7.5 7.85802 7.27614 7.85802 7C7.85802 6.72386 8.08188 6.5 8.35802 6.5C8.63417 6.5 8.85802 6.72386 8.85802 7Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Reliable by Design',
      description:
        'Close technical collaboration to ensure solutions align with real production needs',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <Typography
            variant="text-md"
            color="grayDark-300"
            weight="medium"
            className={styles.label}
          >
            Why EPEN
          </Typography>
          <Typography
            variant="display-md"
            as="h2"
            color="grayDark-50"
            weight="semibold"
            className={styles.heading}
          >
            Built for teams that demand performance, reliability, and clarity
          </Typography>
        </div>
        <div className={styles.pillarsGrid}>
          {pillars.map((pillar, index) => (
            <Reveal
              key={index}
              keyframes={flipFromLeft}
              duration={1000}
              delay={100 * index}
              triggerOnce
            >
              <div className={styles.pillarCard}>
                <div className={styles.iconWrapper}>{pillar.icon}</div>
                <Typography
                  variant="text-lg"
                  as="h3"
                  color="grayDark-50"
                  weight="semibold"
                  className={styles.pillarTitle}
                >
                  {pillar.title}
                </Typography>
                <Typography
                  variant="text-md"
                  color="grayDark-600"
                  className={styles.pillarDescription}
                >
                  {pillar.description}
                </Typography>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyEpen;
